import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import { withRouter } from "react-router-dom";
import s from "./styles.scss";
import {
  Button,
  Row,
  Col,
  Container,
  Label,
  Input,
  FormGroup,
  CustomInput
} from "reactstrap";
import ModalFrame from "../../../toolkit/modalFrame";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

interface Props {
  isOpen: boolean;
  onOk: () => any;
  numeroAutorizacion: string;
  showCheck: boolean;
  setTokenizar: () => any;
  forceTokenization: boolean;
}

interface State {
  check: boolean;
}

class ReimpresionModal extends React.Component<Props, State> {
  state = {
    check: false
  };

  componentWillUnmount() {
    this.setState({ check: false });
  }

  render() {
    return (
      <ModalFrame
        title={"Intelipos"}
        isOpen={this.props.isOpen}
        toggle={() => {}}
        size="md"
      >
        <Container className="p-2">
          <Row className="mt-3">
            <Col xs={12}>
              <h5 className={s.label}>
                {`Número de autorización de cargo: ${this.props.numeroAutorizacion}`}
              </h5>
            </Col>
          </Row>
          {this.props.showCheck ? (
            <Row className="mt-3  p-2">
              <Col xs={12}>
                <FormGroup>
                  <Input
                    type="checkbox"
                    checked={!!this.props.forceTokenization || this.state.check}
                    onChange={e => {
                      this.setState({ check: e.target.checked });
                      this.props.setTokenizar();
                    }}
                    disabled={!!this.props.forceTokenization}
                  />
                  Registrar tarjeta como medio de pago principal
                </FormGroup>
              </Col>
            </Row>
          ) : null}

          {!this.props.showCheck ? (
            <Row className="mt-3  p-2">
              <Col xs={12}>
                <div className="alert alert-warning">
                  <FontAwesomeIcon
                    icon={faExclamationTriangle}
                    className="mr-2"
                  />
                  La tarjeta con la que realizó el pago no generó token por lo
                  tanto no se puede registrar el medio de pago
                </div>
              </Col>
            </Row>
          ) : null}

          <hr />
          <Row className={`${s.customDistancia}`}>
            <Col xs={6} md={6} lg={6}></Col>
            <Col xs={6} md={6} lg={6}>
              <Button block color="secondary" onClick={this.props.onOk}>
                GUARDAR CARGO
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFrame>
    );
  }
}

export default withRouter(withStyles(s)(ReimpresionModal));
